import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {SliderRating} from './styles';

class SliderRatingComponent extends Component {
  static propTypes = {
    device: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
    max: PropTypes.number,
    min: PropTypes.number,
    onChange: PropTypes.func,
    SliderComponent: PropTypes.elementType.isRequired,
    value: PropTypes.number
  };

  render() {
    const {device, max = 100, min = 0, onChange, SliderComponent, value} = this.props;

    return (
      <SliderRating device={device}>
        <SliderComponent
          defaultValue={min}
          marks={{
            [max]: {label: max, style: {color: '#000'}},
            [min]: {label: min, style: {color: '#000'}}
          }}
          max={max}
          min={min}
          onChange={onChange}
          value={value}
        />
      </SliderRating>
    );
  }
}

export default SliderRatingComponent;
